import { render, staticRenderFns } from "./conferences.vue?vue&type=template&id=9d3e5998&"
import script from "./conferences.vue?vue&type=script&lang=js&"
export * from "./conferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports